import React from "react"
import classes from "./StaticProductGridItem.module.css"
import { productPagePath } from "../../../../root/routing/urls"
import { Product } from "../../../../types/product"
import classNames from "classnames"
import { useLabels } from "../../../../features/contents/hooks"
import ProductLabel from "../../../../ui/molecules/Product/ProductLabel"
import Square from "../../../../ui/shapes/Square"
import { SanityImg } from "../../../../cms/components"
import { toTitleCase } from "../../../../utils/strings"
import ProductPrice from "../../../../ui/molecules/Product/ProductPrice"
import Typography from "../../../../ui/atoms/Typography"
import ProductBadges from "../../../../ui/organisms/Product/ProductBadges"

export interface StaticProductGridItemProps {
  product: Product
  className?: string
  lineXs?: boolean
  textLeftXs?: boolean
  verticalPriceXs?: boolean
}

const StaticProductGridItem = ({
  product,
  className,
  lineXs,
  textLeftXs,
  verticalPriceXs,
}: StaticProductGridItemProps) => {
  const { getLabel } = useLabels()
  const variant = product.defaultVariant

  const price = variant.inventory?.price ?? 0
  const url = productPagePath(variant.info.slug ?? product.info.slug)
  const isAvailable = variant.inventory?.available ?? false

  return (
    <div
      className={`relative px-2 pb-0 pt-7 sm:m-2 sm:p-4 sm:pt-7 ${
        className ?? ""
      }`}
    >
      <Square
        className="img-container"
        contentClassName="flex items-center justify-center"
      >
        {variant.media.productImages?.[0] && (
          <SanityImg
            asset={variant.media.productImages[0]?.asset}
            h100
            fluid
            srcImgWidth={250}
            alt={[
              toTitleCase(variant.contents?.name ?? ""),
              variant.metadata.brand?.name,
            ]
              .filter((x) => x)
              .join(" ")}
          />
        )}
      </Square>
      <div className={classes.badges}>
        <ProductBadges
          new={product.characteristics?.new}
          pricing={
            variant.inventory
              ? {
                  discountPercent: variant.inventory.discountPercent ?? 0,
                }
              : undefined
          }
          promoLogoUrl={product.extraData?.promotions?.[0]?.logoUrl}
          promoLogoUrlWidth={36}
          promoLogoClassName={classes.promoLogo}
          noPromo={product.extraData?.noPromo}
          badgeClassName="mr-1"
        />
      </div>
      <div>
        <ProductLabel
          productLink={url}
          title={product.metadata.brand?.name}
          subtitle={variant.contents?.name?.toLowerCase()}
          category={
            product.metadata.categoryPath?.[
              product.metadata.categoryPath.length - 1
            ]?.name
          }
          mobileCenter={!textLeftXs}
          className={classNames(classes.descriptions, {
            [classes.descriptionsLineXs]: lineXs,
          })}
          ellipses={false}
        />
        {isAvailable && price > 0 ? (
          <ProductPrice
            layout="horizontal"
            layoutXs={verticalPriceXs ? "vertical" : "horizontal"}
            compareAtPrice={variant.inventory?.compareAtPrice}
            price={price}
            small
            mobileCenter={!textLeftXs}
          />
        ) : (
          <Typography
            variant="subtitle2"
            textClassName={`${!textLeftXs ? "text-center" : ""} sm:text-left`}
          >
            {getLabel("product", "out-of-stock")}
          </Typography>
        )}
      </div>
    </div>
  )
}

export default StaticProductGridItem
